"use client";

import { CommandInput } from "@layer/ui/components";
import { useTranslations } from "next-intl";

type CommandBarInputType = {
	searchCommand: string;
	setSearchCommand: (value: string) => void;
};

const CommandBarInput = ({
	searchCommand,
	setSearchCommand,
}: CommandBarInputType) => {
	const t = useTranslations("Navigation.command");

	return (
		<CommandInput
			placeholder={t("typeCommand")}
			value={searchCommand}
			onValueChange={(value) => setSearchCommand(value)}
		/>
	);
};

export { CommandBarInput };
